
<template>
    <div class="info-widget">
        <div class="back-button">
          <md-button type="button" class="simple-link " @click="$emit('setSubFull')">
            <i class="mdi mdi-arrow-left"></i> {{ i18n.lbl_go_back() }}
          </md-button>
        </div>
        <div class="container-header">
        <div class="container-header__title sub-title"><p>{{ i18n.lbl_subs() }}</p>
          <md-button class="md-button btn md-primary md-theme-default w-100 sub-button md-button-small" @click="$emit('toggleAdd')">{{ i18n.th_sub() }}</md-button>
        </div>
        <div class="info-widget__actions btn-wrap">
            <div class="container-header__select container select-wrap">
              <select-field
              :label="i18n.lbl_exchange_asset()"
              v-model="asset"
              :values="Object.keys(accountBalances)"
              class="no_border"
              :clearable="true"
              />
            </div>
            <md-button type="button" class="simple-link" :class="{'focused': groupedByClientName}" @click="reByClientName">
            {{ i18n.lbl_group_name() }}
            </md-button>
            <md-button type="button" class="simple-link" :class="{'focused': groupedByName}" @click="reByName">
            {{ i18n.lbl_group_decs() }}
            </md-button>
        </div>
      </div>
      <div class="main-wallet" v-if="mainWallets.length">
        <p v-for="wallet in mainWallets" :key="`main-${wallet.WalletId}`" class="main-wallet-action">
          <span>{{ i18n.lbl_no_funds() }} - {{ wallet.Balance }} {{ wallet.Asset }}</span>
          <md-button class="md-button btn md-primary md-theme-default md-button-small" @click="setActiveTransferMain(wallet)">
            {{ i18n.lbl_sub_transfer() }}
          </md-button>
        </p>
      </div>
      <div class="sub-container" v-if="groupedByClientName || groupedByName">
        <md-button type="button" v-if="!groupedByName" class="simple-link" :class="{'focused': groupByinnerDescription }" @click="reByInnerName">
            {{ i18n.lbl_add_group_decs() }}
            </md-button>
        <md-button type="button" v-if="!groupedByClientName" class="simple-link" :class="{'focused': groupByinnerClient }" @click="reByInnerClient">
            {{ i18n.lbl_add_group_client() }}
         </md-button>
      </div>
      <div class="titles">
        <p>{{ groupedByClientName ? i18n.lbl_client() : i18n.lbl_direction() }}</p>
        <p>{{ groupedByClientName ? i18n.lbl_direction() : i18n.lbl_client() }}</p>
        <p>{{ i18n.lbl_balance() }}</p>
      </div>
      <md-card class="container container_15_0 info-widget__content">
        <md-list class="info-widget__list list_no-background md-layout" v-if="formatedList && formatedList.length">
          <md-list-item v-for="(wallet, index) in formatedList" class="info-widget__item" :key="`walletinfo-${index}`" :md-ripple="false">
            <AccordionSubWallet v-if="Array.isArray(wallet)" :wallet="wallet"
            :groupedByClientName="groupedByClientName"
            :groupByinnerClient="groupByinnerClient" :groupByinnerDescription="groupByinnerDescription"
            @setActiveSubwallet="setActiveSubwallet" @groupInner="groupInner"/>
            <div class="w100 wallet-item" v-else>
                <div @click="$emit('setActiveSubwallet', wallet)" class="text_medium protfolio-subwallet subwallets-flex">
                    <span class="wallet-field">{{ groupedByClientName ? wallet.ClientName : wallet.Description }}</span>
                    <span class="wallet-field">{{ groupedByClientName ? wallet.Description : wallet.ClientName}}</span>
                    <div class="wallet-field">
                        <span class="subwallet-balance">{{ wallet.Balance }}</span>
                        <span>{{ wallet.Asset }}</span>
                    </div>
                </div>
            </div>
          </md-list-item>
        </md-list>
        <h1 v-else>{{ i18n.lbl_no_wallets() }}</h1>
      </md-card>
      </div>
  </template>
<script>
    /* eslint-disable */
import { i18n } from '@js/i18n'
import SelectField from '@com/fields/SelectField'
import AccordionSubWallet from './AccordionSubWallet.vue'

export default {
  name: 'SubWalletsWidget',
  props: ['subwallets', 'accountBalances', 'currentAsset', 'filtered'],
  emits: ['setSubFull', 'setActiveSubwallet', 'toggleAdd'],
  components: { SelectField, AccordionSubWallet },
  data () {
    return {
      i18n,
      groupedByName: false,
      groupedByClientName: false,
      groupByinnerDescription: false,
      groupByinnerClient: false,
      activeGroup: '',
      asset: ''
    }
  },
  created () {
    this.asset = this.currentAsset
  },
  computed: {
    formatedList () {
      if (this.groupedByName) {
        return this.groupSubWalletByName
      } else if (this.groupedByClientName) {
        return this.groupSubWalletByClientName
      }
      return this.groupByCurrency
    },
    groupByCurrency () {
      if (this.filtered && this.asset) {
        return this.filtered.filter(wallet => wallet.Asset === this.asset)
      }
      return this.filtered
    },
    mainWallets () {
      if (this.subwallets) {
        if (this.asset) {
          return this.subwallets.filter(wallet => wallet.Description === 'main' && wallet.Asset === this.asset)
        }
        return this.subwallets.filter(wallet => wallet.Description === 'main')
      }
      return []
    },
    groupSubWalletByName () {
      if (this.groupByCurrency.length) {
        const map = new Map()
        const result = []
        this.groupByCurrency.forEach(wallet => {
          const desc = wallet.Description
          if (map.has(desc)) {
            map.get(desc).push(wallet)
          } else {
            map.set(desc, [wallet])
          }
        })
        map.forEach(group => {
          if (group.length > 1) {
            result.push(group)
          } else {
            result.push(group[0])
          }
        })
        return result
      }
      return []
    },
    groupSubWalletByClientName () {
      if (this.groupByCurrency.length) {
        const map = new Map()
        const result = []
        this.groupByCurrency.forEach(wallet => {
          const desc = wallet.ClientName
          if (map.has(desc)) {
            map.get(desc).push(wallet)
          } else {
            map.set(desc, [wallet])
          }
        })
        map.forEach(group => {
          if (group.length > 1) {
            result.push(group)
          } else {
            result.push(group[0])
          }
        })
        return result
      }
      return []
    }
  },
  methods: {
    reByName () {
      this.groupedByClientName = false
      this.groupedByName = !this.groupedByName
    },
    reByClientName () {
      this.groupedByName = false
      this.groupByinnerClient = false
      this.groupByinnerDescription = false
      this.groupedByClientName = !this.groupedByClientName
    },
    reByInnerName () {
      this.groupByinnerClient = false
      this.groupByinnerDescription = !this.groupByinnerDescription
    },
    reByInnerClient () {
      this.groupByinnerDescription = false
      this.groupByinnerClient = !this.groupByinnerClient
    },
    setActiveGroup (val) {
      if (val === this.activeGroup) {
        this.activeGroup = ''
      } else {
        this.activeGroup = val
      }
    },
    setActiveSubwallet (val) {
      this.$emit('setActiveSubwallet', val)
    },
    setActiveTransferMain (val) {
      this.$emit('setActiveSubwallet', {...val, transfer: val.WalletId})
    }
  },
  watch: {
    asset () {
      this.groupedByName = false
      this.groupedByClientName = false
      this.groupByinnerClient = false
      this.groupByinnerDescription = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '~scss/variables.scss';
@import '~scss/mixins.scss';
.focused {
  opacity: 0.4;
}
.main-wallet-action {
  display: flex;
  align-items: center;
  gap: 10px;
}
.sub-title {
  display: flex;
  gap: 5px;
  align-items: center;
}
.subwallets-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .wallet-field {
      display: block;
      width: 33%;
      text-align: right;
      &:nth-child(2) {
        text-align: center;
      }
      &:first-child {
        text-align: left;
      }
    }
}
.w100 {
    width: 100%;
}

.back-button {
  display: flex;
  justify-content: start;
}
.titles {
  display: flex;
  padding: 15px 40px;
  color: $default-black;
  font-size: 18px;
  p {
    width: 33%;
    &:nth-child(2) {
      text-align: center;
    }
    &:last-child {
      text-align: right;
    }
  }
}
/deep/ .back-button .md-ripple {
    padding: 0;
}
.main-wallet {
  font-size: 18px;
  color: $default-black;
  padding-bottom: 15px;
  border-bottom: 1px solid $default-black;
  margin-bottom: 30px;
}
.btn-wrap {
  display: flex;
  align-items: center;
}

.select-wrap {
  margin-right: 16px;
  max-width: 200px;
}


.info-widget {
    display: flex;
    flex-direction: column;
    flex: 3 3 auto;

    @include respond-to(medium) {
      max-width: inherit;
    }

    @include respond-to(xsmall) {
      max-width: 100%;
    }

    &__content {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      justify-content: space-between;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      transition: all 0.4s ease-in-out;
      & /deep/ .md-list-item-content {
        padding: 0;
      }

      &:not(:last-child) {
        border-bottom: 1px solid $col-border;
      }
      &:hover {
        background-color: $defalut-gray;
      }
    }

    &__name {
      letter-spacing: .2px;
    }

    &__counterparty,
    &__converted {
      margin: 12px 0;
      white-space: nowrap;
    }

    &__counterparty {
      max-width: 400px;
      min-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      @include respond-to(medium) {
        max-width: 300px;
      }
    }

    &__item--opacity {
      opacity: .7;
    }

    &__amount {
      font-weight: 700;
    }

    &__amount--in { color: $col-success; }
    &__amount--out { color: $col-error; }
    &__amount--pending { color: orange; }
    &__amount--failed { color: $col-disabled; }

    &__state {
      & .cell-state__inner {
        position: relative;

        &:after {
          content: url("/static/img/success_icon.svg");
          position: absolute;
          top: 50%;
          left: -20px;
          max-height: 22px;
          transform: translateY(-50%);
        }

        &.success {
          color: $col-success;
        }
        &.pending {
          color: orange;
          &:after {
            content: url("/static/img/pending_icon.svg");
          }
        }
        &.fully, &.matched, &.fully_matched {
          color: $col-disabled;
          &:after {
            content: '';
          }
        }
        &.rejected,
        &.failed {
          color: $col-invalid;
          &:after {
            content: '';
          }
        }
      }
    }

    &__item-left {
      flex: 1 1 auto;
      @include respond-to(xsmall) {
        flex: none;
        width: 130px;
      }
    }

    &__item-right {
      flex: 0 0 auto;
      text-align: right;

      @include respond-to(xsmall) {
        flex: none;
        width: calc(100% - 130px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/Dashboard.SubWalletsWidget.vue